import React from "react";

interface Props {
  // A member who already holds a Pass, upgrading, rather than a new buyer.
  forMember: boolean;
}

const LifetimeSubscription: React.FC<Props> = ({ forMember }) => {
  return (
    <p className="subtitle" id="formSubtitle">
      {forMember
        ? "You've proven you'll use it. This just retires the recurring bill."
        : "One payment. Every course we have, and every one we make after. No renewals, ever."}
    </p>
  );
};

export default LifetimeSubscription;
